import axios from "axios";

export const api = axios.create({
  baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`,
  withCredentials: true,
});

const NO_REFRESH = ["/auth/refresh", "/auth/login", "/auth/register", "/auth/logout"];
let refreshing: Promise<unknown> | null = null;

api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config || {};
    const url: string = original.url || "";
    if (error.response?.status === 401 && !original._retry && !NO_REFRESH.some((p) => url.includes(p))) {
      original._retry = true;
      try {
        refreshing = refreshing || api.post("/auth/refresh");
        await refreshing;
        refreshing = null;
        return api(original);
      } catch {
        refreshing = null;
      }
    }
    return Promise.reject(error);
  },
);

export function apiError(e: any): string {
  const detail = e?.response?.data?.detail;
  if (e?.response?.status === 429 && !detail) return "Too many requests — take a breath and try again.";
  if (detail == null) return e?.message ? "Network hiccup — please try again." : "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (typeof d?.msg === "string" ? d.msg.replace(/^Value error, /, "") : "")).join(" ");
  return String(detail?.msg || detail);
}
